var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.599%",
    y1: "146.559136%",
    x2: "73.8446667%",
    y2: "52.3813953%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095D5",
    offset: "9.677%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#238AD9",
    offset: "30.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#557BDE",
    offset: "62.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7472E2",
    offset: "86.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806EE3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.9840532%",
    y1: "37.1049231%",
    x2: "68.682392%",
    y2: "-13.5538462%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095D5",
    offset: "11.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C83DC",
    offset: "41.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D74E1",
    offset: "69.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806EE3",
    offset: "83.33%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.8361667%",
    y1: "91.9396667%",
    x2: "76.2191667%",
    y2: "-1.11566667%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C757BC",
    offset: "10.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0609A",
    offset: "21.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1725C",
    offset: "42.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7E2F",
    offset: "60.48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58613",
    offset: "74.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88909",
    offset: "82.32%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-1)",
    points: "0 256 128.426667 127.573333 256 256"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-2)",
    points: "0 0 128.426667 0 0 138.666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-3)",
    points: "128.426667 0 0 135.253333 0 256 128.426667 127.573333 256 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.dacec53b41519d5b844a780e625cb099.svg";
export { ForwardRef as ReactComponent };